// extracted by mini-css-extract-plugin
export default {"container":"_2LqbiTvaVJ1BI7v7ra9g","feature-spotlight":"kQBKbih2juCfvUIu__EI","link":"ZiDnK1BuqL7KB4oC5Jna"};